// Define an interface for the tag data
export interface IPortalDetail {
  id: number;
  status: string;
  description: string;
  title: string;
  location: any;
  author: string;
  category: string;
  organizationId: string;
  specie: any;
  publisher: string;
  materialCreationDate: string;
}

export interface IfetchPortalDetail {
  data: IPortalDetail;
  message: string;
  stateIs: "Idle" | "Pending" | "Error";
}

// Create an initial state object for portal detail
const initialDataPortalDetailState: IfetchPortalDetail = {
  data: {
      id: 0,
      status: "",
      description: "",
      title: "",
      location: null,
      author: "",
      category: "",
      organizationId: "",
      specie: null,
      publisher: "",
      materialCreationDate: "",
  },
  message: "",
  stateIs: "Idle",
};

export default initialDataPortalDetailState;
